import { factoryService, getFileRequest, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets the Framework Agreement's documents.
 */
export const getDocumentsFrameworkAgreement = factoryService(({ dni }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/onboarding/proveedor/${`${normalizeDniSlashes(dni)}/` ?? ''}convenio-marco/documentos`
  )
)

/**
 * Download a document by the given identifier.
 */
export const frameworkDownloadDocument = factoryService(({ id }) =>
  getFileRequest(`${REACT_APP_API_BASE_URL}/v1/onboarding/convenio-marco/documento/${id}`)
)
